import { useMutation } from "@tanstack/react-query";
import { deviceApis } from "../../../../../../shared/apis/device/apis";

export function useRegisterMutation() {
  const { mutate: postDispatchDevices } = useMutation(deviceApis.shipment.postDispatchDevices);
  const { mutate: putDispatchDevices } = useMutation(deviceApis.shipment.putDispatchDevices);

  return { postDispatchDevices, putDispatchDevices };
}
